export const HOME = '/';

export const PROJECTS = '/projects';

export const ABOUT = '/about';

export const UNAUTHORIZED = '*';